// @ts-nocheck
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Container, Stack, Center } from '@/components/ui/layout';
import { Title, Text, Button, Anchor, Badge } from '@/components/ui/core';
import { TextInput } from '@/components/ui/inputs';
import { IconArrowLeft, IconMail, IconColumns, IconCheck, IconShieldLock, IconClock, IconHeadset } from '@tabler/icons-react';
import { FadeIn, SlideIn } from '@/components/animations';
import { SplitScreenLayout } from '../components';

const features = [
  {
    icon: <IconShieldLock size={20} />,
    title: 'Secure Process',
    description: 'Your account security is our priority',
  },
  {
    icon: <IconClock size={20} />,
    title: 'Quick Recovery',
    description: 'Reset your password in minutes',
  },
  {
    icon: <IconHeadset size={20} />,
    title: '24/7 Support',
    description: 'Our team is here to help anytime',
  },
];

export default function ForgotSplitScreen() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
  };

  return (
    <SplitScreenLayout
      ratio="50-50"
      leftContentType="image"
      imageUrl="https://images.unsplash.com/photo-1614064641938-3bbee52942c7?w=1200&q=80"
      gradientFrom="orange"
      gradientTo="red"
      overlayOpacity={0.75}
      title="Password Recovery"
      subtitle="We'll help you regain access to your account safely and securely."
      features={features}
    >
      <Container size="xs" w="100%">
        <Stack gap="lg">
          <Button
            component={Link}
            to="/app/demo/auth-pages/forgot-password"
            variant="subtle"
            size="xs"
            leftSection={<IconArrowLeft size={14} />}
            w="fit-content"
          >
            Back to variants
          </Button>

          {submitted ? (
            <FadeIn>
              <Stack gap="lg" align="center">
                <Center
                  style={{
                    width: 80,
                    height: 80,
                    borderRadius: 20,
                    backgroundColor: 'var(--mantine-color-green-light)',
                  }}
                >
                  <IconCheck size={40} color="var(--mantine-color-green-6)" />
                </Center>

                <Stack align="center" gap="xs">
                  <Title order={2} ta="center">Check your email</Title>
                  <Text c="dimmed" ta="center" maw={300}>
                    We've sent a password reset link to <strong>{email}</strong>
                  </Text>
                </Stack>

                <Stack gap="sm" w="100%">
                  <Button
                    component="a"
                    href="https://mail.google.com"
                    target="_blank"
                    fullWidth
                    size="md"
                    variant="gradient"
                    gradient={{ from: 'orange', to: 'red' }}
                  >
                    Open email app
                  </Button>
                  <Button
                    variant="subtle"
                    fullWidth
                    onClick={() => setSubmitted(false)}
                  >
                    Didn't receive the email? Try again
                  </Button>
                </Stack>

                <Anchor component={Link} to="/app/demo/auth-pages/login/splitscreen" size="sm">
                  <IconArrowLeft size={14} style={{ marginRight: 4, verticalAlign: 'middle' }} />
                  Back to login
                </Anchor>
              </Stack>
            </FadeIn>
          ) : (
            <>
              <FadeIn delay={100}>
                <Stack gap="xs" align="center">
                  <Badge
                    leftSection={<IconColumns size={12} />}
                    variant="gradient"
                    gradient={{ from: 'orange', to: 'red' }}
                    size="lg"
                  >
                    Split Screen
                  </Badge>
                  <Title order={2} ta="center" mt="md">
                    Forgot password?
                  </Title>
                  <Text c="dimmed" size="sm" ta="center" maw={320}>
                    No worries! Enter your email address and we'll send you a link to reset your password.
                  </Text>
                </Stack>
              </FadeIn>

              <SlideIn direction="up" delay={200}>
                <form onSubmit={handleSubmit}>
                  <Stack gap="md">
                    <TextInput
                      label="Email address"
                      placeholder="you@example.com"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      leftSection={<IconMail size={16} />}
                      required
                    />

                    <Button
                      type="submit"
                      fullWidth
                      size="md"
                      variant="gradient"
                      gradient={{ from: 'orange', to: 'red' }}
                    >
                      Send reset link
                    </Button>
                  </Stack>
                </form>
              </SlideIn>

              <FadeIn delay={300}>
                <Center>
                  <Anchor component={Link} to="/app/demo/auth-pages/login/splitscreen" size="sm">
                    <IconArrowLeft size={14} style={{ marginRight: 4, verticalAlign: 'middle' }} />
                    Back to login
                  </Anchor>
                </Center>
              </FadeIn>
            </>
          )}
        </Stack>
      </Container>
    </SplitScreenLayout>
  );
}
